/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section2_Li1Inputs */

const en_about_section2_li1 = /** @type {(inputs: About_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Client-Side: All processing happens in your browser using JavaScript. No data is ever transmitted to any server.`)
};

const ko_about_section2_li1 = /** @type {(inputs: About_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% 클라이언트 사이드: 모든 처리가 JavaScript를 사용하여 브라우저에서 이루어집니다. 어떤 데이터도 서버로 전송되지 않습니다.`)
};

const ja_about_section2_li1 = /** @type {(inputs: About_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100%クライアントサイド：すべての処理がJavaScriptを使用してブラウザで行われます。データがサーバーに送信されることはありません。`)
};

/**
* | output |
* | --- |
* | "100% Client-Side: All processing happens in your browser using JavaScript. No data is ever transmitted to any server." |
*
* @param {About_Section2_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section2_li1 = /** @type {((inputs?: About_Section2_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section2_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section2_li1(inputs)
	if (locale === "ko") return ko_about_section2_li1(inputs)
	return ja_about_section2_li1(inputs)
});